<template> 
    <div class="newsletter-container">
        <div class="flex newsletter-content center ma-auto">
            <div class="modal-information">
                <template
                    v-if="newsletterState !== 'success'"
                >
                    <div class="first-step" v-if="recipeCoupon && !secondStep">
                        <sign-up-content @recipeCoupon="toSecondStep()"></sign-up-content>
                    </div>
                    <div class="first-step" v-if="!recipeCoupon && !secondStep">
                        <img  
                            :src="$root.source === 'bennet' ? 'https://api.quomi.it/oldimg/Logo_InstaCook-quadrato_colore.webp' : 'https://api.quomi.it/oldimg/quomi-logo-small.webp'" 
                            alt="logo"
                            :style="$root.source === 'bennet' ? 'max-width: 20%' : '' "
                        />
                        <h2>
                            Promo di Benvenuto!
                        </h2>

                        <img src="https://api.quomi.it/oldimg/40-euro-sconto-instacook.webp" class="my-2" loading="lazy" v-if="$root.source === 'bennet'">
                        <img src="https://api.quomi.it/oldimg/popup-quomi-50.webp" class="my-5" loading="lazy" v-else>
                        <p 
                            style="font-size: 14px"
                            v-html="$root.source === 'bennet' ? 'Ricevi 10 euro di sconto sui tuoi primi 4 ordini di almeno 39 euro.<br>Per un risparmio totale di 40 euro!' : 'Ricevi 10€ di <b>sconto</b> sulle tue prime 5 spese, per un risparmio totale di <b>50€</b>! <br> In più ottieni la <b>consegna gratuita</b> sul primo ordine!'"
                        />
                        <CTA
                            :content="`Si, ne approfitto!`"
                            @click="toSecondStep()"
                        />
                        <div
                            v-if="newsletterFlash"
                            class="flash"
                            :class="newsletterState"
                        >
                            {{ newsletterFlash }}
                        </div>
                    </div>
                    <div class="second-step" v-if="secondStep">
                        <img  
                            :src="$root.source === 'bennet' ? 'https://api.quomi.it/oldimg/Logo_InstaCook-quadrato_colore.webp' : 'https://api.quomi.it/oldimg/quomi-logo-small.webp'" 
                            alt="logo"
                            :style="$root.source === 'bennet' ? 'max-width: 20%' : '' "
                        />
                        <h2>Ci siamo quasi!</h2>
                        <img src="https://api.quomi.it/oldimg/Icona-Bennet.webp" class="my-5" v-if="$root.source === 'bennet'">
                        <img src="https://api.quomi.it/oldimg/success-quomi.webp" class="my-5" v-else>
                        <p v-if="$route.name === 'recipe'">Raggiungi 29€ di spesa.<br>Troverai il tuo sconto nel carrello valido per 3 giorni, per te 10€ sui primi 5 ordini!*</p>
                        <p  
                            v-else
                            v-html="$root.source === 'bennet' ? 'Registrati o Accedi e fai un ordine di almeno 39 euro. Troverai il tuo sconto nel carrello valido per 3 giorni!' : 'Raggiungi 29€ di spesa e registrati,<br>troverai il tuo sconto nel carrello valido per 3 giorni!*'"
                        />
                        <CTA
                            :size="`small`"
                            isArrow	
                            :content="`Attiva la promozione`"
                            @click="onClickCoupon()"
                        />
                        <p v-if="$root.source  !== 'bennet'" style="font-size: 11px; margin-top: 10px;">* Offerta non cumulabile con altri coupon/sconti, promozioni e/o Ticket Restaurant®</p>
                    </div>
                </template>

                <!--<template
                    v-if="newsletterState !== 'success'"
                >
                    <h2>
                        Vuoi fare una spesa di ricette con ingredienti freschi e di stagione?
                    </h2>
                    <p>
                        Inserisci la tua mail per ricevere l'offerta sulla tua <b>prima Box</b> a partire da soli <s><nobr>{{ '19,90' | priceFilter }}</nobr></s>
                        <b><nobr> {{ '9,90' | priceFilter }}</nobr></b>
                    </p>
                    <form
                        role="form"
                        method="POST"
                        name="newsletter"
                        action=""
                        @submit.prevent="$_newsletter_newsletterSubscribe({ email: email })"
                    >
                        <div>
                            <input
                                type="email"
                                v-model="email"
                                class="form-control"
                                required
                                placeholder="Inserisci la mail"
                            >
                        </div>

                        <checkbox
                            @checkboxEvent="checked = $event"
                        >
                            <template slot="label">
                                Accetto la
                                    <router-link :to="{name: 'privacy'}" class="link-detail" title="Privacy policy">
                                        privacy policy
                                    </router-link>
                                di Quomi
                            </template>
                        </checkbox>

                        <CTA
                            :content="`Si, voglio il mio buono prova`"
                            type="submit"
                            :disabled="!checked || newsletterLoading"
                        />
                    </form>

                    <div
                        v-if="newsletterFlash"
                        class="flash"
                        :class="newsletterState"
                    >
                        {{ newsletterFlash }}
                    </div>

                </template>-->

                <template
                    v-if="newsletterState === 'success'"
                >
                    <div class="inner">
                        <p
                            v-if="newsletterFlash"
                            class="flash"
                            :class="newsletterState"
                        >
                            <i class="fa fa-check" aria-hidden="true"></i> {{ newsletterFlash }}
                        </p>

                        <br>
                        <p>
                            <b>Condividi con gli amici questa novità in cucina:</b>
                        </p>
                        <social-share
                            :facebook="'https://goo.gl/hS5QBM'"
                        />
                    </div>
                </template>

            </div>

            <!--<div
                class="modal-image"
                v-if="$mq.isDesktop()"
            >
                <img src="../../assets/img/popup-box.jpg">
            </div>-->
        </div>
    </div>

</template>

<script>

import { newsletter } from '../../mixins/newsletter'
import { container } from '../../services/container'
import SocialShare from '../SocialShare/SocialShare'
import Checkbox from '../Checkbox'
import SignUpContent from '../SignUpContent'
import SignInContent from '../SignInContent.vue'

export default {
    data () {
        return {
            checked: false,
            email: null,
            secondStep: false
        }
    },
    props: {
        recipeCoupon: {
            type: Boolean,
            default: false
        }
    },

    mixins: [
        newsletter
    ],

    components: {
        SocialShare,
        Checkbox,
        SignUpContent,
    },

    methods: {
        afterSuccess () {
            this.$emit('afterSuccess')
        },
        onClickCoupon() {
            var cookies = container.get('services.cookies')
            if (this.$root.source === 'bennet') {
                cookies.set('coupon', 'KX5FH2')
            }else if(this.$route.name === 'recipe') {
                cookies.set('coupon', 'VI7DIX')
            }else{
                cookies.set('coupon', 'MDYRSW')
            }
            this.$emit('hideCoupon')
            if (this.$root.source === 'bennet') {
                this.$router.push('/checkout/scegli-ricette?coupon=KX5FH2')
            }else if(this.$route.name === 'recipe') {
                this.$router.push('/checkout/scegli-ricette?coupon=VI7DIX')
            }else{
                this.$router.push('/checkout/scegli-ricette?coupon=MDYRSW')
            }
        },

        toSecondStep() {
            this.secondStep = true
        }
    }
}

</script>

<style scoped>
.newsletter-container {
    overflow: hidden;
    padding: 30px;
    border-radius: 6px;
    display: flex;
}

.newsletter-content {
    margin: 0 -10px;
}

.conditions {
    font-size: 18px;
}

h2 {
    font-weight: bold;
    text-align: center;
}

button.btn.btn-green,
button.btn.btn-green:hover {
    margin: 0;
}

.first-step p{
    font-size: 23px;
}

p,
.btn,
.btn:hover {
    font-size: 20px;
}

div img:first-child{
    max-width: 30%;
    margin-bottom: 15px;
}

div img {
    max-width: 80%
}

small {
    font-size: 75%;
}

@media (max-width: 640px) {
    .first-step p,
    .second-step p {
        font-size: var(--recipes-info-font-mobile);
    }
}

@media (max-width: 1024px) {
    p, .btn {
        font-size: 16px;
    }

    * >>> .conditions {
        font-size: 14px;
    }
}

.modal-information {
    margin: 0 20px 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.modal-information .inner {
    margin: auto 0;
}

.btn {
    width: 100%;
    margin: 0;
    padding: 15px 15px
}

.btn span  {
    white-space: normal;
}
.modal-image {

    flex-basis: 927px;
    margin: -30px -30px -30px 10px;
    filter: saturate(150%);
}

.flash {
    margin: 10px auto 0 auto;
}

.flash.error {
    color: tomato;
}

.flash.success {
    color: var(--quomi-primary);
}

@media (min-width: 1440px) {

h2 {
    font-size: 20px;
}

p,
.btn,
.btn:hover {
    font-size: 14px;
}

.first-step img {
    max-width: 70%;
}

.first-step p{
    font-size: 16px;
}

.newsletter-container {
    padding: 15px;
}

button.btn.btn-green,
button.btn.btn-green:hover {
    width: 80%;
    margin: 0 auto;
}

}

</style>
